import { gql } from 'graphql-request';

const PrintingToolModel = gql`
  {
    commonTips: __type(name: "CommonTips") {
      name
      enumValues {
        name
        description
      }
    }
    signedTipOptions: __type(name: "SignedTipOptions") {
      name
      enumValues {
        name
        description
      }
    }
  }
`;

export { PrintingToolModel };
